import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ContractConfirmation } from '../entities/contract-confirmation.entity';

export const contractConfirmationActions = createActionGroup({
  source: 'ContractConfirmation',
  events: {
    'Load Required Contract Confirmations': emptyProps(),
    'Accept Contracts': emptyProps(),
  },
});

export const contractConfirmationApiActions = createActionGroup({
  source: 'ContractConfirmation API',
  events: {
    'Load Required Contract Confirmations Success': props<{ contractConfirmations: ContractConfirmation[] }>(),
    'Load Required Contract Confirmations Failure': props<{ error: HttpErrorResponse }>(),
    'Accept Contracts Success': emptyProps(),
    'Accept Contracts Failure': props<{ error: HttpErrorResponse }>(),
  },
});
